import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getUserCompaniesIds = (state) => get(state, 'companies.result.companies', []);
export const getUserCompanies = (state) => get(state, 'companies.entities.userCompanies', {});
export const getCompanies = (state) => get(state, 'companies.entities.companies', {});
export const getIsLoading = (state) => get(state, 'companies.isLoading', {});

export const getVisibleCompanies = createSelector(
  [getUserCompaniesIds, getUserCompanies, getCompanies],
  (ids, userCompanies, companies) =>
    ids.map((id) => companies[userCompanies[id].company]).filter((company) => company)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/selectors/companies_selectors.js